define('viewmodels/app/reporting/index',[
        'plugins/router',
        'durandal/app', 'knockout', 'jquery', 'lodash', 'moment', 'atn/atn', '../__allCharts', 'dataSource/session',
        'dataSource/reporting/reporting', 'dataSource/reporting/reportingPdfDownload',
        '../components/__reportScheduleForm', 'chartApi/index', '../__config', '../__utils','../__subrouter'
    ],
    function(
        rootRouter, app, ko, $, _, moment, atn, allCharts, session, reportingDataSource, reportingPdfDownload, reportScheduleForm,
        chartApi, config, utils, router
    ) {

        'use strict';

        var scrollBarPosition = ko.observable(0);
        var initScrollPosition = ko.observable(null);
        var emptyAccordion = ko.observable(true);
        var reportType = ko.observable("CHART");
        
        /**
         * [scheduleTypeMapping mapping of the schedule type of the reports]
         * @type {Object}
         */
        var scheduleTypeMapping = {
            'ONE_TIME': atn.config.messages.reporting.oneTimeReporting,
            'RECURRING': atn.config.messages.reporting.recurringReporting
        };

        /**
         * [scheduleTypeMapping mapping of the schedule type of the reports]
         * @type {Object}
         */
        var scheduleUnitMapping = {
            'DAY': atn.config.messages.reporting.intervals.DAY,
            'WEEK': atn.config.messages.reporting.intervals.WEEK,
            'MONTH': atn.config.messages.reporting.intervals.MONTH
        };

        var reportList = ko.computed(createReportsGridList);

        return {
            activate: activate,
            reportList: reportList,
            isInternetExplorer: atn.utils.isInternetExplorer,
            scrollBarPosition: scrollBarPosition,
            emptyAccordion: emptyAccordion,
            reportingMessages: atn.config.messages.reporting,
            showSummary: showSummary,
            scheduleTypeMapping: scheduleTypeMapping,
            createReport: createReport,
            editReport: editReport,
            popupDeleteReport: popupDeleteReport,
            popupEmailReport: popupEmailReport,
            generatePdf: generatePdf,
            reportIdPollStatusMap: reportingPdfDownload.reportIdPollStatusMap,
            reportPollCodes: reportingPdfDownload.reportPollCodes,
            cancelClickOnElem: cancelClickOnElem,
            initScrollPosition: initScrollPosition,
            reportType: reportType,
            isLoading: reportingDataSource.isLoading
        };

        /**
         * [activate This function is the activate function of the viewModel. Whenever the route is invoked this function gets triggered]
         * @return {promise}         [the promise for the activation of the viewModel]
         */
        function activate(reportTypeParam) {
                reportType(null);
                var dashboardsPromise = allCharts.loadDashboards(); // this will trigger allCharts.activeDashboard.subscribe
                dashboardsPromise.done(function () {
                    var deferred = $.Deferred(),
                            promise = reportingDataSource.getReportsList(true);
                    emptyAccordion(true);
                    promise.done(function () {
                        reportType(reportTypeParam ? reportTypeParam : "CHART");
                        deferred.resolve(reportingDataSource.reportsList());
                    });
                    promise.fail(function () {
                        reportType(reportTypeParam ? reportTypeParam : "CHART");
                        deferred.reject(false);
                    });
                    return deferred.promise();
                });

                dashboardsPromise.fail(function () {
                    _.defer(rootRouter.navigate, '#site/failure/dataFetch');
                });
        }

        /**
         * for popup to delete a schedule
         * {object} data  [current row object i.e. current report object]
         * @return {undefined}
         */
        function popupDeleteReport(data) {
            var displayName = data.name,
                reportId = data.reportScheduleId,
                choiceYes = atn.config.messages.popupChoices.DELETE,
                choiceNo = atn.config.messages.popupChoices.CANCEL;

            var promise = app.atnCustomDialog(
                atn.utils.sformat(atn.config.messages.deletion.reporting.text, displayName),
                atn.config.messages.deletion.reporting.heading, [choiceYes, choiceNo]
            );

            promise.done(function(choice) {
                if (choice === choiceYes) {
                    deleteReportSchedule(displayName, reportId);
                }
            });
        }


        function deleteReportSchedule(displayName, reportId) {
            reportingDataSource.deleteReportSchedule(reportId).done(function() {
                atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.deleteSuccess, displayName));
            }).fail(function() {
                atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.deleteFailed, displayName));
            });
        }

        /**
         * for popup to send report now
         * {object} data  [current row object i.e. current report object]
         * @return {undefined}
         */
        function popupEmailReport(data) {
            var displayName = data.name,
                reportId = data.reportScheduleId,
                choiceYes = atn.config.messages.popupChoices.YES,
                choiceNo = atn.config.messages.popupChoices.CANCEL;

            var promise = app.atnCustomDialog(
                atn.utils.sformat(atn.config.messages.emailnow.reporting.text, displayName),
                atn.config.messages.emailnow.reporting.heading, [choiceYes, choiceNo]
            );

            promise.done(function(choice) {
                if (choice === choiceYes) {
                    emailReport(displayName, reportId);
                }
            });
        }
        
        function emailReport(displayName, reportId) {
            reportingDataSource.emailReport(reportId).done(function() {
                atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.emailNowSuccess, displayName));
            }).fail(function() {
                atn.toasterRegistry.addToasterMessage(atn.utils.sformat(atn.config.messages.reporting.emailNowFailed, displayName));
            });
        }
        
        /**
         * function to convert GET call response to UI grid required format.
         * @return {array} array of grid required objects
         */
        function createReportsGridList() {
            var activeMessageObj = atn.config.messages.popupChoices,
                list = {
                    chart: [],
                    rawData: []
                };
            initScrollPosition(null);

            if (!_.isEmpty(reportingDataSource.reportsList())) {

                _.forEach(reportingDataSource.reportsList(), function(report, index) {
                    var reportObject = {
                        chartConfigs: utils.reportSummaryFromModel(report.chartConfigs()),
                        reportScheduleId: report.reportScheduleId(),
                        timezone: report.timezone(),
                        timeZoneOffsetStr: report.timeZoneOffsetStr(),
                        name: report.name(),
                        reportType: report.reportType(),
                        scheduleType: scheduleTypeMapping[report.scheduleType()],
                        oneTimeScheduleTime: atn.utils.dateToFormattedString(report.oneTimeScheduleTime(), false),
                        recurringScheduleStart: atn.utils.dateToFormattedString(report.recurringScheduleStart(), false),
                        recurringScheduleEnd: atn.utils.dateToFormattedString(report.recurringScheduleEnd(), false),
                        nextDeliveryTime: atn.utils.dateToFormattedString(report.nextDeliveryTime(), false),
                        recurringScheduleInterval: report.recurringScheduleInterval(),
                        recurringScheduleUnit: scheduleUnitMapping[report.recurringScheduleUnit()],
                        scheduleEmailRecipients: report.scheduleEmailRecipients(),
                        scheduleActive: report.scheduleActive() ? activeMessageObj.YES : activeMessageObj.NO,
                        isSummaryHidden: ko.observable(true),
                        isExpanded: ko.observable((!list.chart.length && report.reportType() === 'CHART') || (!list.rawData.length && report.reportType() === 'RAW_DATA'))
                    };
                    if(reportObject.reportType === 'CHART'){
                        list.chart.push(reportObject);
                    }else if(reportObject.reportType === 'RAW_DATA'){
                        list.rawData.push(reportObject);
                    }
                });

            }

            _.defer(initScrollPosition,0);

            return list;
        }

        function showSummary(data) {
            if(data.reportType == "RAW_DATA"){
                router.navigate("#app/schedule/edit/" + data.reportScheduleId);
            }else{
                data.isSummaryHidden(!data.isSummaryHidden());
            }
        }

        function createReport() {
            router.navigate("#app/schedule/new/" + reportType());
        }

        function editReport(data) {
            router.navigate("#app/schedule/edit/" + data.reportScheduleId);
        }

        function generatePdf(data, event) {
            reportingPdfDownload.downloadPdfReport(data.reportScheduleId, openReportingWindowCb);
        }

        function cancelClickOnElem(data, event){
            event.stopPropagation();
        }


        function openReportingWindowCb(value) {
            if (value.length) {
                window.open(value, '_blank');
            }
        }

    });
